import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IListViewsPlanning } from '@shared/interfaces/list-views-planning';
import { DayPlanning } from '@shared/interfaces/planning/day-planning.interface';
import { ApiService } from '@shared/services/api.service';
import { format } from 'date-fns';
import { PrimeNGConfig } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GeneralPlanningService {

  public datePlanningCached: Date = new Date();
  public dateCollectedCached: Date = new Date();
  public viewCached: IListViewsPlanning = {
    hours: false,
    days: false,
    months: true,
  };
  public scrollMonthPositionCached: number = 0;
  public scrollDayPositionCached: number = 0;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private primengConfig: PrimeNGConfig,
    private dialogService: DialogService,
  ) { }



}
